module.exports = __webpack_public_path__ + "public/img/dianziyouhuiquan.8654b5ea.png";